<template>
  <div class="box">
    <div class="content w-1400">
      <div class="logo-word">
        <!-- <img class="logo-big" src="../../static/index/hualianwang.png"/> -->
        <!--        <div class="word-big">-->
        <!--          <div class="china-word">化联网</div>-->
        <!--          <div class="english-word">Ruitian Huagong</div>-->
        <!--        </div>-->
      </div>
      <div class="flex-inner-right">
        <div class="flex-inner-right-box">
          <div class="flex-inner-right-box-title">绑定手机号</div>

          <div class="input-box">
            <el-form
                :model="registerForm"
                :rules="registerRules"
                ref="registerForm"
                label-position="left"
            >
              <el-form-item prop="mobile">
                <el-input
                    placeholder="请输入手机号"
                    v-model="registerForm.mobile"
                >
                  <i slot="prefix">
                    <img
                        :src="require('../../static/login/phone.png')"
                        alt=""
                    />
                  </i>
                </el-input>
              </el-form-item>
              <el-form-item prop="code">
                <el-row>
                  <el-col :span="14">
                    <el-input
                        placeholder="请输入验证码"
                        v-model="registerForm.code"
                    >
                      <i slot="prefix">
                        <img
                            class="input-icon"
                            src="../../static/login/code.png"
                            alt=""
                        /></i>
                    </el-input>
                  </el-col>
                  <el-col :span="9" :offset="1">
                    <div class="btn-code" v-if="time == 0" @click="getCode">
                      获取验证码
                    </div>
                    <div class="btn-code" v-else>{{ time }}秒后获取</div>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-form>
          </div>

          <div class="login-box">
            <el-button class="btn-size" type="primary" @click="goRegister"
            >绑定
            </el-button
            >
            <div class="login-box-text">
              <div class="top-inner">
                <span class="color-blue" @click="goHome">返回首页</span>
                |
                已有账号？
                <span class="color-blue" @click="goLogout">退出登录</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {register, checkPhone, sendSmsCode} from "@/api/modules/user";
import {bindPhone} from "../../api";

export default {
  data() {
    return {
      activeIndex: 1,
      registerForm: {
        mobile: "",
        code: "",
      },
      time: "", //倒计时
      registerRules: {
        mobile: [
          {required: true, message: "请输入手机号码", trigger: "blur"},
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        code: [
          {required: true, message: "请输入验证码", trigger: "blur"},
          {min: 4, max: 6, message: "验证码长度应为4-6位", trigger: "blur"},
        ],
      },
    };
  },
  methods: {
    goHome() {
      this.$router.push("/");
    },
    goLogout() {
      this.$utils.logout(this.$store, this.$router);
      this.showUser = false;

      this.$message.success({
        message: "退出成功",
        duration: 2000,
        offset: 200,
      });
    },
    toastMessage(e) {
      if (e.target.value) {
        // 校验手机号格式是否正确
        if (!this.validateMobile(e.target.value)) {
          return
        }
        checkPhone({mobile: e.target.value}).then(res => {
          if (res.data.code != 10000) {
            this.$confirm(res.data.message, "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
              closeOnClickModal: false,
              closeOnPressEscape: false,
              showClose: true,
            }).catch(() => {
              this.registerForm.mobile = ''
            })
          } else {
            this.getCode()
          }
        })
      }
    },
    // 校验手机号码格式的方法
    validateMobile(mobile) {
      const mobilePattern = /^1[3-9]\d{9}$/;
      return mobilePattern.test(mobile);
    },
    // 获取验证码
    getCode() {
      if (!this.registerForm.mobile) {
        this.$message({
          type: 'error',
          message: `请输入手机号！`
        });
        return
      }
      // 校验手机号格式是否正确
      if (!this.validateMobile(this.registerForm.mobile)) {
        this.$message({
          type: 'error',
          message: `请输入正确的手机号码！`
        });
        return
      }

      this.time = 59;
      let timer = setInterval(() => {
        this.time--;
        if (this.time <= 0) {
          clearInterval(timer);
        }
      }, 1000);

      sendSmsCode({mobile: this.registerForm.mobile, type: '4'}).then(res => {
        if (res.data.code != 10000) {
          this.$message({
            type: 'error',
            message: res.data.message
          })
        } else {
          this.$message.success("验证码已发送");
        }
      })
    },

    goRegister() {
      this.$refs["registerForm"].validate((valid) => {
        if (valid) {
          this.register();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async register() {
      try {
        let res = await bindPhone(this.registerForm);
        if (res.data.code === 10000) {
          this.$store.dispatch('GET_USER_INFO')
          this.$message.success({
            message: "绑定成功!将跳转至首页",
            center: true,
            offset: 250,
          });
          setTimeout(() => {
            this.$router.push("/");
          }, 2000);
        } else {
          this.$message.error({
            message: res.data.message,
            center: true,
            offset: 250,
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style scoped lang="scss">
.btn-code {
  width: 100px;
  height: 40px;
  background: #ebebeb;
  border-radius: 2px 2px 2px 2px;
  border: 1px solid #eef0f5;
  text-align: center;
  line-height: 40px;
  font-weight: 400;
  font-size: 14px;
  color: #00112b;
  cursor: pointer;
}

.box {
  width: 100vw;
  height: 100vh;
  background: url("../../static/login/login-bj.png") no-repeat center center;
  background-size: 100% 100%;

  .content {
    padding-top: 109px;
    display: flex;
    justify-content: space-between;

    .logo-word {
      height: 61px;
      display: flex;
      color: #000000;
      //width: 172px;
      align-items: center;
      margin-right: 32px;

      .logo-big {
        width: 200px;
        height: 62px;
        object-fit: contain;
      }

      .word-big {
        margin-left: 10px;

        .china-word {
          white-space: nowrap;
          font-size: 22px;
          // color: #00112b;
          color: #ffffff;
          font-weight: 700;
        }

        .english-word {
          white-space: nowrap;
          font-size: 11px;
          color: #ffffff;
        }
      }
    }

    .flex-inner-right {
      width: 380px;
      background: #ffffff;
      box-shadow: 0px 0px 11px 1px rgba(0, 11, 28, 0.13);
      border-radius: 5px 5px 5px 5px;
      box-sizing: border-box;
      margin-top: 8%;

      .flex-inner-right-img {
        position: absolute;
        margin-left: 334px;
        padding: 3px 3px 0 0;
        width: 44px;
        height: 44px;
      }

      .flex-inner-right-box {
        //float: left;
        padding: 30px 13px 30px;

        width: 100%;
        height: 100%;
        box-sizing: border-box;

        .flex-inner-right-box-title {
          font-weight: 800;
          font-size: 20px;
          color: #00112b;
          text-align: center;
        }

        .menu-box {
          padding-top: 20px;
          display: flex;
          align-content: center;
          border-bottom: 1px solid #e5e5e5;
          justify-content: space-around;
        }

        .menu-item {
          box-sizing: border-box;
          text-align: center;
          font-weight: bold;
          font-size: 14px;
          color: #00112b;
          padding-bottom: 12px;
          border-bottom: 1px solid transparent;
        }

        .menu-item-active {
          box-sizing: border-box;
          text-align: center;
          font-weight: bold;
          font-size: 14px;
          padding-bottom: 12px;
          color: #00112b;
          border-bottom: 1px solid #246dff;
        }

        .input-box {
          padding: 30px 40px 0;

          img {
            width: 13px;
            height: 13px;
          }

          .input-item {
            margin-bottom: 30px;

            .input-error {
              line-height: 30px;
              font-weight: 400;
              font-size: 12px;
              color: #eb5637;
            }

            .input-item-box {
              height: 40px;
              line-height: 40px;
              background: #ffffff;
              border-radius: 2px 2px 2px 2px;
              border: 1px solid #eef0f5;
              padding: 0 13px;

              img {
                width: 13px;
                height: 13px;
                margin-right: 15px;
              }

              input {
                border: none;

                &:focus {
                  outline: none;
                  /* 移除默认的轮廓线 */
                  box-shadow: none;
                  /* 移除可能的阴影效果 */
                  border: none;
                  /* 确保没有边框 */
                  -webkit-appearance: none;
                  /* 移除iOS上的默认样式 */
                  -moz-appearance: none;
                  /* 移除Firefox上的默认样式 */
                }

                /* 移除自动填充时的背景色 */
                &:-webkit-autofill,
                &:-webkit-autofill:hover,
                &:-webkit-autofill:focus {
                  -webkit-box-shadow: 0 0 0 30px white inset !important;
                }
              }
            }
          }
        }

        .login-box {
          padding: 0 40px;

          .btn-size {
            width: 100%;
            height: 40px;
          }

          .login-box-text {
            font-weight: 400;
            font-size: 13px;
            color: #00112b;
            text-align: center;
            padding-top: 30px;
          }

          .color-blue {
            color: #0c60e6;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
